var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgResetPasswordFormPageGraphic(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 385,
    viewBox: "0 0 1440 385",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1835_15295)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-27 254.647H1445.81V431.461H-27V254.647Z",
    fill: "#FFF8E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M862 246.676C862 313.623 908.542 349.147 1440.23 349.147C1969.08 349.147 2019.94 321.291 2019.94 246.676H862Z",
    fill: "#FADE92"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M888.878 246.676C888.878 299.697 933.259 327.829 1440.23 327.829C1930.59 327.829 1991.58 299.707 1991.58 246.676",
    fill: "#FADE92"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M888.878 246.676C888.878 299.697 933.258 327.829 1440.23 327.829C1930.59 327.829 1991.58 299.707 1991.58 246.676",
    stroke: "white",
    strokeWidth: 0.563366,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M911.361 246.676C911.361 285.842 953.932 306.625 1440.23 306.625C1910.6 306.625 1969.09 285.842 1969.09 246.676",
    fill: "#FADE92"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M911.361 246.676C911.361 285.842 953.932 306.625 1440.23 306.625C1910.6 306.625 1969.09 285.842 1969.09 246.676",
    stroke: "white",
    strokeWidth: 0.563366,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M935.476 246.676C935.476 273.187 986.407 287.253 1440.23 287.253C1868.26 287.253 1944.98 273.191 1944.98 246.676",
    fill: "#FADE92"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M935.476 246.676C935.476 273.187 986.407 287.253 1440.23 287.253C1868.26 287.253 1944.98 273.191 1944.98 246.676",
    stroke: "white",
    strokeWidth: 0.563366,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1252.4 216.607L1230.43 268.552C1230.28 268.909 1230.03 269.214 1229.7 269.428C1229.38 269.643 1229 269.758 1228.61 269.759H1225.49C1225.19 269.759 1224.88 269.689 1224.61 269.554C1224.34 269.418 1224.1 269.221 1223.91 268.978C1223.73 268.736 1223.6 268.453 1223.55 268.154C1223.49 267.854 1223.5 267.545 1223.58 267.251L1238.38 214.007L1252.4 216.607Z",
    fill: "#669C92"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1637.29 148.421C1619.02 148.421 1620.26 149.839 1614.23 143.809C1609.3 138.884 1606.34 124.32 1594.07 94.5223C1581.8 64.7246 1571.72 59.4639 1546.3 59.4639H1287.15C1261.73 59.4639 1251.65 64.7224 1239.38 94.5223C1227.11 124.322 1224.15 138.884 1219.23 143.809C1213.19 149.839 1214.46 148.421 1196.16 148.421C1184.26 148.421 1165.82 157.357 1172.21 166.258C1201.13 206.573 1241 227.757 1278.69 227.757H1554.76C1592.45 227.757 1632.32 206.573 1661.24 166.258C1667.63 157.357 1649.19 148.421 1637.29 148.421Z",
    fill: "#80C4B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1225.24 169.498C1225.24 169.498 1227.4 172.729 1233.07 180.91C1237.67 187.531 1240.46 190.988 1246.83 190.988H1570.03C1573.22 189.955 1581.38 185.383 1588.54 175.355",
    stroke: "#454C5D",
    strokeWidth: 0.442267,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1569.29 126.598C1554.56 125.105 1530.46 129.302 1521.56 131.463C1512.65 133.623 1501.9 124.411 1490.23 128.398C1478.56 132.385 1426.97 190.769 1474.26 190.769H1567.62C1580.52 190.769 1585.28 169.54 1584.43 157.563C1583.58 145.587 1592.45 128.946 1569.29 126.598Z",
    fill: "#FEFBF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1246.3 138.097C1258.89 130.479 1276.09 129.829 1284.92 132.254C1308.22 138.654 1306.56 151.867 1318.23 155.854C1329.9 159.841 1369.53 190.758 1322.23 190.758H1246.62C1234.89 190.758 1226.12 168.971 1229.82 157.552C1233.15 147.23 1241.11 141.237 1246.3 138.097Z",
    fill: "#FFE4B9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1310.3 165.186C1299.31 155.797 1276.04 149.07 1259.35 145.034",
    stroke: "#454C5D",
    strokeWidth: 0.442267,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-49 0V168.819H96.5333V0H-49ZM92.1673 164.453H-44.634V4.366H92.1673V164.453Z",
    fill: "#E8EDFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.0768 43.0567C61.1549 37.0054 37.0254 30.5758 16.3655 51.9255C5.12742 63.5391 7.42976 83.5004 -11.9262 87.5695C-27.6612 90.879 -51.0805 130.729 7.49088 130.729C52.938 130.729 87.7583 69.6864 66.0768 43.0567Z",
    fill: "#E8EDFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.672 301.498H139.16L164.966 335.504C165.401 336.076 165.962 336.54 166.606 336.859C167.25 337.178 167.959 337.344 168.677 337.343H175.931C176.117 337.343 176.301 337.298 176.466 337.212C176.632 337.126 176.774 337.001 176.882 336.848C176.989 336.696 177.058 336.52 177.083 336.335C177.108 336.15 177.088 335.962 177.025 335.786L164.672 301.498Z",
    fill: "#E8EDFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-39.1475 168.815H200.237C201.473 168.815 202.657 169.306 203.53 170.179C204.404 171.053 204.894 172.237 204.894 173.472V296.841C204.894 298.076 204.404 299.261 203.53 300.134C202.657 301.007 201.473 301.498 200.237 301.498H-39.1475V168.815Z",
    fill: "#E8EDFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.421 238.232H-39.1475V295.421H191.348C192.095 295.423 192.832 295.244 193.495 294.902C194.159 294.559 194.73 294.061 195.161 293.451C195.592 292.841 195.87 292.136 195.971 291.396C196.073 290.655 195.995 289.902 195.743 289.198L178.917 242.095C178.512 240.962 177.766 239.983 176.782 239.291C175.798 238.6 174.624 238.23 173.421 238.232Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4155 264.498H-5.54744C-6.83346 264.498 -7.87598 265.54 -7.87598 266.826C-7.87598 268.112 -6.83346 269.155 -5.54744 269.155H29.4155C30.7015 269.155 31.744 268.112 31.744 266.826C31.744 265.54 30.7015 264.498 29.4155 264.498Z",
    fill: "#D7DDF7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.474 174.972H-39.1475V232.161H189.398C190.144 232.161 190.88 231.981 191.542 231.638C192.205 231.294 192.775 230.797 193.205 230.187C193.635 229.577 193.912 228.872 194.013 228.133C194.114 227.393 194.035 226.641 193.784 225.938L176.955 178.834C176.551 177.704 175.808 176.726 174.826 176.035C173.845 175.343 172.674 174.972 171.474 174.972Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4155 201.231H-5.54744C-6.83346 201.231 -7.87598 202.274 -7.87598 203.56C-7.87598 204.846 -6.83346 205.888 -5.54744 205.888H29.4155C30.7015 205.888 31.744 204.846 31.744 203.56C31.744 202.274 30.7015 201.231 29.4155 201.231Z",
    fill: "#D7DDF7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.65 107.22V99.3379C103.651 99.2088 103.695 99.0838 103.775 98.9825C103.855 98.8813 103.967 98.8095 104.092 98.7785C104.217 98.7475 104.349 98.759 104.467 98.8113C104.585 98.8636 104.683 98.9536 104.744 99.0672L108.446 106.024C109.005 107.074 109.433 108.19 109.718 109.345L123.34 164.097L117.691 165.503L104.072 110.751C103.786 109.596 103.644 108.41 103.65 107.22V107.22Z",
    stroke: "#454C5D",
    strokeWidth: 0.582133,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.733 96.1332L115.972 88.1085C115.988 88.0492 116.022 87.9966 116.07 87.9581C116.118 87.9197 116.177 87.8974 116.239 87.8945C116.3 87.8916 116.361 87.9082 116.412 87.9419C116.464 87.9757 116.503 88.0248 116.525 88.0823L119.546 95.845L123.01 165.614L117.188 165.905L113.733 96.1332Z",
    stroke: "#454C5D",
    strokeWidth: 0.582133,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.365 103.718L137.068 100.807C137.168 100.637 137.322 100.506 137.506 100.435C137.689 100.364 137.892 100.357 138.08 100.415C138.268 100.473 138.431 100.594 138.542 100.756C138.653 100.919 138.706 101.114 138.692 101.311L138.456 104.676C137.952 111.845 136.626 118.933 134.507 125.801L122.241 165.526L114.455 163.122L126.721 123.397C128.839 116.528 131.74 109.925 135.365 103.718V103.718Z",
    stroke: "#454C5D",
    strokeWidth: 0.582133,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.923 125.155H106.235C105.592 125.155 105.07 125.676 105.07 126.319V167.651C105.07 168.294 105.592 168.815 106.235 168.815H135.923C136.566 168.815 137.088 168.294 137.088 167.651V126.319C137.088 125.676 136.566 125.155 135.923 125.155Z",
    fill: "#FFF3E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8291 111.38C7.84514 108.498 14.1846 144.777 4.73946 112.2C4.73946 112.2 -3.46571 115.964 -13.5628 112.681C-23.6599 109.397 -28.3461 75.59 -11.9183 81.7228C4.50951 87.8556 -15.2044 99.2304 -14.3836 75.6773C-13.5628 52.1242 -2.06277 54.1035 6.15113 57.0141C14.365 59.9248 21.4263 70.3159 17.6919 76.6204C13.9575 82.9249 -8.21301 65.0359 11.4922 53.2419C31.1974 41.4479 48.0676 55.4104 44.3594 67.3208C40.6513 79.2313 38.2762 71.9546 41.1257 65.6763C43.9752 59.398 53.7813 57.3401 52.3492 75.6773C50.9172 94.0145 39.8334 71.0203 54.6137 68.1416C69.3941 65.263 81.7353 107.57 52.3492 107.57C17.7414 107.57 47.2468 87.0609 44.3594 97.1086C41.4721 107.156 30.8452 117.736 15.8291 111.38Z",
    stroke: "#6D80C9",
    strokeWidth: 0.582133,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.73926 112.201C19.1849 105.663 19.3595 91.5843 11.8966 88.6882C4.43364 85.7921 2.076 102.933 19.4643 94.2447C36.8526 85.5564 28.5107 76.8826 28.5107 76.8826",
    stroke: "#6D80C9",
    strokeWidth: 0.582133,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.2016 143.443H-3.01172V148.101H55.2016V143.443Z",
    fill: "#FDE2BA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1116.34 50.322C1116.34 50.322 1118.16 13.2036 1131.38 14.013C1139.06 14.4779 1138.75 30.414 1116.34 50.322Z",
    fill: "#BFE1DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1111.93 60.6083C1111.93 60.6083 1112.29 43.1986 1106.72 30.8629C1100.26 16.5044 1092.6 18.5003 1092.72 27.2643C1092.98 43.536 1111.93 60.6083 1111.93 60.6083Z",
    fill: "#BFE1DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1105.22 82.532C1105.22 82.532 1099.92 65.4508 1091.08 56.4624C1082.25 47.474 1071.1 52.8261 1077.95 65.7595C1085.71 80.4051 1104.28 86.6062 1104.28 86.6062",
    fill: "#BFE1DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1100.12 114C1100.12 114 1090.29 101.774 1076.56 93.8714C1062.83 85.9689 1052.32 90.788 1057.7 100.469C1065.63 114.767 1099.87 117.146 1099.87 117.146",
    fill: "#BFE1DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1100.85 101.855C1100.85 101.855 1116.64 83.4921 1132.4 75.638C1143.81 69.952 1150.01 81.769 1138.38 89.4059C1122.09 100.101 1100.85 101.855 1100.85 101.855Z",
    fill: "#BFE1DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1097.96 132.342C1097.96 132.342 1111.72 111.502 1135.75 101.378C1149.78 95.469 1160.24 107.424 1144.97 118.401C1123.46 133.864 1097.96 132.342 1097.96 132.342Z",
    fill: "#BFE1DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1100.79 172.721C1100.79 172.721 1113.11 153.278 1133.71 140.746C1154.31 128.215 1165.02 139.353 1152.26 150.756C1131.28 169.503 1100.79 172.721 1100.79 172.721Z",
    fill: "#BFE1DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1107.38 191.645C1107.38 191.645 1091.33 173.535 1078 167.826C1045.11 153.731 1040.58 180.092 1079.8 193.368C1094.21 198.248 1108.21 195.077 1108.21 195.077",
    fill: "#BFE1DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1118 48.2632C1117.25 49.7816 1116.54 51.3718 1115.87 52.9548C1115.19 54.5379 1114.55 56.1478 1113.93 57.7631C1112.69 60.9938 1111.55 64.2537 1110.5 67.543C1108.4 74.124 1106.63 80.8001 1105.18 87.5713C1103.74 94.3425 1102.61 101.154 1101.79 108.005C1100.96 114.861 1100.47 121.755 1100.27 128.645C1099.89 142.443 1100.78 156.246 1102.91 169.883L1103.32 172.435C1103.39 172.861 1103.46 173.286 1103.54 173.709L1103.77 174.98C1103.92 175.827 1104.06 176.678 1104.23 177.522L1104.74 180.058C1104.9 180.903 1105.08 181.745 1105.28 182.587L1105.82 185.11L1106.42 187.623L1106.71 188.879C1106.81 189.299 1106.92 189.714 1107.03 190.136C1108.71 196.818 1110.67 203.418 1112.92 209.936L1109.52 211.086C1107.33 204.448 1105.43 197.725 1103.82 190.916C1103.72 190.491 1103.61 190.067 1103.52 189.64L1103.23 188.362L1102.67 185.803L1102.15 183.236C1101.97 182.38 1101.79 181.526 1101.64 180.664L1101.17 178.089C1101.01 177.231 1100.88 176.366 1100.73 175.506L1100.52 174.214C1100.44 173.783 1100.38 173.352 1100.31 172.92L1099.93 170.33C1097.96 156.5 1097.26 142.519 1097.83 128.561C1098.13 121.592 1098.73 114.637 1099.65 107.727C1100.57 100.817 1101.81 93.95 1103.36 87.1585C1104.92 80.3669 1106.79 73.649 1109 67.0405C1110.11 63.7392 1111.3 60.4685 1112.59 57.2283C1113.23 55.6118 1113.91 54.0048 1114.61 52.4074C1115.33 50.81 1116.05 49.236 1116.85 47.6602L1118 48.2632Z",
    fill: "#BFE1DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1107.21 74.4158C1107.21 74.4158 1116.25 63.2252 1126.07 54.4935C1135.17 46.3845 1142.89 55.3406 1134.56 61.1558C1119.64 71.5675 1107.21 74.4158 1107.21 74.4158Z",
    fill: "#BFE1DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1100.05 155.085C1100.05 155.085 1095.59 145.378 1082.3 136.033C1063.07 124.022 1053.73 126.928 1070.32 142.896C1078.91 151.179 1100.05 155.085 1100.05 155.085Z",
    fill: "#BFE1DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1107.46 202.897C1107.46 202.897 1129.75 171.059 1153.05 163.991C1171.76 158.311 1179.17 179.157 1158.36 191.233C1142.37 200.528 1107.46 202.897 1107.46 202.897Z",
    fill: "#BFE1DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1080.33 205.623H1145.39C1145.59 205.622 1145.79 205.663 1145.97 205.743C1146.16 205.823 1146.32 205.94 1146.46 206.088C1146.59 206.235 1146.69 206.408 1146.76 206.598C1146.82 206.787 1146.85 206.987 1146.83 207.186L1140.96 272.481C1140.64 276.053 1139 279.375 1136.35 281.794C1133.7 284.214 1130.25 285.556 1126.66 285.557H1099.06C1095.48 285.557 1092.02 284.215 1089.38 281.795C1086.73 279.375 1085.08 276.053 1084.76 272.481L1078.9 207.186C1078.88 206.988 1078.91 206.788 1078.97 206.599C1079.03 206.41 1079.14 206.237 1079.27 206.089C1079.41 205.942 1079.57 205.825 1079.75 205.745C1079.93 205.664 1080.13 205.623 1080.33 205.623Z",
    fill: "#FAD69E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1103.87 191.31C1103.87 191.31 1085.92 174.259 1063.67 167.9",
    stroke: "#454C5D",
    strokeWidth: 0.358962,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1113.87 198.205C1117.96 194.022 1145.44 171.306 1164.07 167.9",
    stroke: "#4E5D6A",
    strokeWidth: 0.358962,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1108.21 166.743C1116.59 156.997 1137.53 139.169 1152.5 138.205",
    stroke: "#454C5D",
    strokeWidth: 0.358962,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1096.15 151.472C1093.2 148.366 1078.66 135.8 1068.67 131.067",
    stroke: "#454C5D",
    strokeWidth: 0.358962,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1103.81 128.601C1105.75 126.223 1130.64 107.941 1142.81 105.565",
    stroke: "#454C5D",
    strokeWidth: 0.358962,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1096.15 112.911C1093.03 110.253 1073.53 97.0626 1064.38 95.1835",
    stroke: "#454C5D",
    strokeWidth: 0.358962,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1107.93 97.1557C1110.45 94.6914 1128.85 80.8229 1136.86 79.2848",
    stroke: "#454C5D",
    strokeWidth: 0.358962,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1103.12 81.7496C1101.35 78.519 1092.95 65.1872 1084.56 57.9469",
    stroke: "#454C5D",
    strokeWidth: 0.358962,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1112.91 70.1942C1114.83 68.3455 1127.23 57.8692 1132.01 55.5575",
    stroke: "#454C5D",
    strokeWidth: 0.358962,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1110.13 55.172C1108.74 49.3174 1103.74 32.7549 1100.12 27.0546",
    stroke: "#454C5D",
    strokeWidth: 0.358962,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1119.75 42.1073C1122.14 34.9962 1125.46 27.4957 1130.47 18.7496",
    stroke: "#454C5D",
    strokeWidth: 0.358962,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1146.36 212.329L1145.54 221.432H1080.18L1079.36 212.329H1146.36Z",
    fill: "#FDE2BA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1099.01 111.344C1099.26 112.857 1098.53 116.352 1097.06 118.295",
    stroke: "#454C5D",
    strokeWidth: 0.358962,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1835_15295"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 385,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgResetPasswordFormPageGraphic);
export default __webpack_public_path__ + "static/media/ResetPasswordFormPageGraphic.bbbe8d6702e25a67778cfd33f7757c25.svg";
export { ForwardRef as ReactComponent };